<template>
  <div class="table-responsive bg-white rounded">
    <tasks class="m-4" scope="ORGANIZATION"></tasks>
  </div>
</template>

<script>
import Tasks from "./tasks.vue";
export default {
  components: { Tasks },

  computed: {},
};
</script>
